import './consoleGuard'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'
import injectColorsVars from './lib/injectColorsVars'

// Inject runtime CSS variables from central color tokens
injectColorsVars()

// In development, avoid stale PWA service workers (they can break SPA navigation on /appearance, etc.)
if (import.meta?.env?.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .then(() => {
      if ('caches' in window) return caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k))));
      return undefined;
    })
    .catch(() => {});
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
